import React from 'react';
import { useNavigate } from 'react-router-dom';

function ThankYou() {
  const navigate = useNavigate();

  return (
    <div 
      className="thank-you-container"
      style={{
        paddingTop: '160px',
        paddingBottom: '80px',
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center'
      }}
    >
      <h1 style={{ fontSize: '2.2rem', marginBottom: '1rem' }}>
        Thank You!
      </h1>
      <p style={{ fontSize: '1.1rem', marginBottom: '2rem', color: '#555' }}>
        Your enquiry has been sent successfully. We will contact you soon.
      </p>
      <button 
        className="back-home-btn" 
        onClick={() => navigate('/')}
        style={{
          padding: '12px 24px',
          fontSize: '1rem',
          cursor: 'pointer',
          backgroundColor: '#333',
          color: '#fff',
          border: 'none',
          borderRadius: '4px'
        }}
      >
        Back to Homepage
      </button>
    </div>
  );
}

export default ThankYou;